module.exports = __webpack_public_path__ + "img/icon_boy.06dc5608.png";